import "./_select-asset-modal-list-item.scss";

import {ListItem} from "@hipo/react-ui-toolkit";
import {convertFromBaseUnits} from "@tinymanorg/tinyman-js-sdk";

import {AssetListItemData} from "../../../../../asset/util/assetModels";
import {formatAssetAmount} from "../../../../../asset/util/assetUtils";
import DollarValue from "../../../../../component/dollar-value/DollarValue";
import AssetNameWithLogoAndUnit from "../../../../../asset/name/with-logo-and-unit/AssetNameWithLogoAndUnit";

interface SelectAssetModalListItemProps {
  asset: AssetListItemData;
  onSelect: (asset: AssetListItemData) => void;
}

function SelectAssetModalListItem({asset, onSelect}: SelectAssetModalListItemProps) {
  return (
    <ListItem
      clickableListItemProps={{
        onClick: handleSelectAsset
      }}
      id={asset.id}
      customClassName={"select-asset-modal-list-item"}>
      <AssetNameWithLogoAndUnit asset={asset} testid={asset.id} />

      {Boolean(asset.balance) && (
        <div className={"is-flex-column is-aligned-right"}>
          <p className={"typography--caption color--text-gray"}>
            {`Balance ${formatAssetAmount({
              assetDecimals: asset.decimals,
              amount: convertFromBaseUnits(asset.decimals, asset.balance!)
            })}`}
          </p>

          <DollarValue
            assetID={asset.id}
            balance={convertFromBaseUnits(asset.decimals, asset.balance!)}
            textColor={"text-gray-lighter"}
          />
        </div>
      )}
    </ListItem>
  );

  function handleSelectAsset() {
    onSelect(asset);
  }
}

export default SelectAssetModalListItem;
